<template>
<div v-if="!clientUserAgent" id="pageTable">
    <v-container grid-list-xl fluid paddingZero>
        <v-layout row wrap>
            <v-card>
                <v-flex lg12>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>LOAD DETAILS</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="this.$route.meta.type=='loads' ? {name: 'Loads'} : {name: 'SearchLoads'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                </v-flex>
                <v-card-text>
                    <v-layout row wrap>
                        <v-spacer></v-spacer>
                        
                        <div class="v-table__overflow" v-if="load">
                            <table class="custom_table" cellpadding="0" width="100%">
                                <thead>
                                    <tr>
                                        <th width="150px">AGE</th>
                                        <th width="150px">ORIGIN</th>
                                        <th width="150px">DESTINATION</th>
                                        <th width="150px">
                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                <tr>
                                                    <td width="50%">PICKUP</td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">RATE</td>
                                                </tr>
                                            </table>
                                        </th>
                                        <th width="150px">
                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                <tr>
                                                    <td colspan="2">Equipment</td>
                                                </tr>
                                                <tr>
                                                    <td width="39%">Size</td>
                                                    <td width="61%">Length</td>
                                                </tr>
                                            </table>
                                        </th>
                                        <th width="150px">
                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                <tr>
                                                    <td>Distance</td>
                                                </tr>
                                                <tr>
                                                    <td>Weight</td>
                                                </tr>
                                            </table>
                                        </th>
                                        <th width="150px">
                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                <tr>
                                                    <td>PHONE</td>
                                                </tr>
                                            </table>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td align="center">
                                            <v-chip label color="orange" text-color="white">{{utils.getDateDiffDisplay(load.created_date)}} </v-chip>
                                        </td>
                                        <td colspan="2">
                                            <table width="100%" border="0" cellpadding="0" class="subtableNO">
                                                <tr>
                                                    <td width="45%">{{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}}</td>
                                                    <td width="10%" align="center">
                                                        <v-icon color="orange">arrow_forward</v-icon>
                                                    </td>
                                                    <td width="45%">{{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td>
                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                <tr>
                                                    <td align="center">{{load.pickup_date | moment("utc","MM/DD")}}</td>
                                                </tr>
                                                <tr>
                                                    <td align="center">{{load.rate}}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td>
                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                <tr>
                                                    <td colspan="2" align="center">{{load.equipment_name_short_form}}</td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="center">{{load.load_size}}</td>
                                                    <td width="50%" align="center">{{load.length}} ft</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td>
                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                <tr>
                                                    <td align="center">{{load.distance}} Miles</td>
                                                </tr>
                                                <tr>
                                                    <td align="center" class='sm-case'>{{load.weight}} lbs</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td>
                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                <tr rowspan="2">
                                                    <template v-if="load.contact_phone.includes(',')">
                                                        <td align="center"> 
                                                            <a v-for="(valPh, iPh) in load.contact_phone.split(',')" class="link-text" target="_blank"  :href="'tel:' + valPh" >{{valPh | phone}} </br></a>
                                                        </td>
                                                    </template>
                                                    <template v-else>
                                                        <td align="center"> <a class="link-text" target="_blank"  :href="'tel:' + load.contact_phone" >{{load.contact_phone | phone}}</a></td>
                                                    </template>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                           
                            <div class="v-card v-card--flat theme--light"><div class="v-card__text" style="padding:0 8px!important;">
                            <table width="100%" border="0" cellpadding="0" class="viewdetail innerview">
                                <thead>
                                    <tr class="bg-orange">
                                        <th align="center" width="30">
                                            BROKER
                                        </th>
                                        <th align="center" width="30"> LOAD </th>
                                        <th align="center" width="40">OUTBOUND ACTIVITY</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td valign="top" width="33.33%">
                                            <strong>Name:</strong> {{utils.getDataDisplay(load.contact_name)}} <br />
                                            <strong>Phone No.:</strong>
                                            <template v-if="load.contact_phone.includes(',')">
                                                <a v-for="(valPh, iPh) in load.contact_phone.split(',')" class="link-text" target="_blank"  :href="'tel:' + valPh" >{{valPh | phone}}, </a>
                                            </template>
                                            <template v-else>
                                                <span>{{load.contact_phone | phone}}</span>
                                                <a class="link-text" target="_blank"  :href="'tel:' + load.contact_phone" >{{load.contact_phone | phone}}</a>
                                            </template>
                                            <br />
                                            <strong>Email:</strong> <a v-if="load.contact_email && load.contact_email.length > 0" class="link-text" target="_blank"  :href="'mailto:' + load.contact_email" >{{load.contact_email}}</a><span v-if="!load.contact_email || load.contact_email.length == 0">{{notProvidedStr}}</span><br/>
                                            <strong>Company:</strong> <span class="charwrap">{{ utils.getDataDisplay(load.company_name) }} </span><br />
                                            <strong>MC Number:</strong> 
                                            <span v-if="load.load_mc_number && load.load_mc_number.length > 0"> <a class='link-text' :href="mcNumberLocation+load.load_mc_number" target='_blank'>{{load.load_mc_number}}</a></span>
                                            <span v-else>{{notProvidedStr}}</span>
                                            <br />
                                            <span v-if="load.source == 'postonce'"><strong><span style="text-transform: capitalize;">{{load.source}}</span> Member Id:</strong> <span style="text-transform: capitalize;">{{utils.getDataDisplay(load.aggregator_account_name)}}</span><br /><br/></span>
                                            <span v-else><strong>LOADMAX Forum Username:</strong> {{utils.getDataDisplay(load.discourse_user_name)}}<br /></span>
                                            <span v-if="load.frequency != ''"><strong>Recurring: </strong><span>{{utils.getTitleCase(load.frequency)}}<strong> Until </strong>{{load.end_date | moment('YYYY-MM-DD')}}</span></span>
                                        </td>
                                        <td valign="top" width="33.33%">
                                            <strong>Height:</strong> {{load.height}} ft <br />
                                            <strong>Weight:</strong> {{load.weight}} lbs <br />
                                            <strong>Length:</strong> {{load.length}} ft<br />
                                            <strong>Equipment and Accessories:</strong> {{load.equipment_name_long_form}} <br />
                                            <strong>Descriptions and Comments:</strong> {{utils.getDataDisplay(load.description)}} <br />
                                            <!--<strong>Notes:</strong> {{utils.getNotesNameFromKey(load.notes, this.aggregatorsKeyVal, load.source)}}<br />-->
                                            <strong>Notes:</strong> {{((utils.getNotesNameFromKey(load.notes, this.aggregatorsKeyVal, load.source) != notProvidedStr) ? utils.getNotesNameFromKey(load.notes, this.aggregatorsKeyVal, load.source) +  (load.extra_notes != '' ? ','+load.extra_notes : '') : (load.extra_notes != '' ? load.extra_notes : notProvidedStr))}}<br />
                                            <strong>Load ID:</strong> {{ ((load.source == 'posteverywhere') ? notProvidedStr : utils.getDataDisplay(load.reference_number)) }}
                                        </td>
                                        <td valign="top" width="33.33%">
                                            <strong>Outbound:</strong> {{load.dest_city ? load.dest_city+', '+load.dest_short_name : anywhereStr}}:<strong> {{outboundFrieghts.destination_city_loads}} Load(s)</strong> <br/>
                                            <strong>Outbound:</strong> {{load.dest_state ? load.dest_state : anywhereStr}}: <strong> {{outboundFrieghts.destination_state_loads}} Load(s)</strong> <br/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                            </div>
                           
                            <div id="map" style="height:500px;"></div>
                        </div>                        
                    </v-layout>
                    <div style="text-align: center;">{{noLoadExistMsg}}</div>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</div>

<div v-else id="pageTable">
   <div class="v-table__overflow" v-if="load">
        <table class="custom_table mobileview mobileviewfull" cellpadding="0" width="100%">
            <tbody>
                <tr class="custom_table_tr activetd">
                    <td>
                        <table width="100%" border="0" cellpadding="0" class="subtableNO ">
                            <tr>
                                <td width="45%" class="bold" valign="top">
                                    <h1>
                                        {{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}}
                                    </h1>
                                    {{load.pickup_date | moment("dddd, MMMM. Do")}}<br/>
                                    {{utils.getDateDiffDisplay(load.created_date)}}
                                </td>
                                <td width="10%" align="center" valign="top">
                                    <h1>
                                        <v-icon color="orange">arrow_forward</v-icon>
                                    </h1>
                                </td>
                                <td width="45%" class="bold" valign="top">
                                    <h1>
                                        {{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}
                                    </h1>
                                    {{load.load_size}}
                                    <br/>
                                    <!--{{ ((load.source == 'posteverywhere') ? utils.getDataDisplay(load.load_company_name) : utils.getDataDisplay(load.company_name) )}}-->
                                    {{ utils.getDataDisplay(load.company_name) }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <div id="map" style="height:500px;"></div>
                <tr>
                    <td>
                        <div class="mobilefullLoad">
                            <div class='unset-case text-wrap'>
                                <h1>
                                    BROKER
                                    <!-- <i aria-hidden="true" class="v-icon red--text material-icons">
                                        favorite
                                    </i> -->
                                </h1>
                                <strong>Name:</strong> {{utils.getDataDisplay(load.contact_name)}} <br />
                                <strong>Phone:</strong> 
                                <template v-if="load.contact_phone.includes(',')">
                                    <a v-for="(valPh, iPh) in load.contact_phone.split(',')" class="link-text" target="_blank"  :href="'tel:' + valPh" >{{valPh | phone}} </br></a>
                                </template>
                                <template v-else>
                                    <span>{{load.contact_phone | phone}}</span>
                                    <a class="link-text" target="_blank"  :href="'tel:' + load.contact_phone" >{{load.contact_phone | phone}}</a>
                                </template>
                                <!--<strong>Company:</strong> {{ ( (load.source == 'posteverywhere') ? utils.getDataDisplay(load.load_company_name) : utils.getDataDisplay(load.company_name))}} <br />-->
                                <strong>Company:</strong> {{ utils.getDataDisplay(load.company_name) }} <br />
                                <strong>Email:</strong> <a v-if="load.contact_email && load.contact_email.length > 0" class="link-text" target="_blank"  :href="'mailto:' + load.contact_email" >{{load.contact_email}}</a><span v-if="!load.contact_email || load.contact_email.length == 0">{{notProvidedStr}}</span><br/>
                                <strong>MC Number:</strong> {{(load.mc_number && load.mc_number.length > 0)?'':notProvidedStr}}  <a v-if="load.mc_number && load.mc_number.length > 0" class="link-text" :href="mcNumberLocation+load.mc_number" target="_blank">{{load.mc_number}}</a><br />
                                <span v-if="load.source == 'postonce'"><strong><span style="text-transform: capitalize;">{{load.source}}</span> Member Id:</strong> <span style="text-transform: capitalize;">{{utils.getDataDisplay(load.aggregator_account_name)}}</span><br /></span>
                                <span v-else><strong>LOADMAX Forum Username:</strong> {{utils.getDataDisplay(load.discourse_user_name)}}<br /></span>
                                <span v-if="load.frequency != ''"><strong>Recurring: </strong><span>{{utils.getTitleCase(load.frequency)}}<strong> Until </strong>{{load.end_date | moment('YYYY-MM-DD')}}</span></span>
                            </div>
                            <div class='unset-case'>
                                <h1>LOAD</h1>
                                <strong>Height:</strong> {{load.height}} ft<br/>
                                <strong>Weight:</strong> {{load.weight}} lbs<br/>
                                <strong>Length:</strong> {{load.length}} ft<br />
                                <strong>Equipment and Accessories:</strong> {{load.equipment_name_long_form}} <br />
                                <strong>Descriptions and Comments:</strong> {{utils.getDataDisplay(load.description)}} <br />
                                <!--<strong>Notes:</strong> {{utils.getNotesNameFromKey(load.notes, this.aggregatorsKeyVal, load.source)}}<br />-->
                                <strong>Notes:</strong> {{((utils.getNotesNameFromKey(load.notes, this.aggregatorsKeyVal, load.source) != notProvidedStr) ? utils.getNotesNameFromKey(load.notes, this.aggregatorsKeyVal, load.source) +  (load.extra_notes != '' ? ','+load.extra_notes : '') : (load.extra_notes != '' ? load.extra_notes : notProvidedStr))}}<br />
                                <strong>Load ID:</strong> {{ ((load.source == 'posteverywhere') ? notProvidedStr : utils.getDataDisplay(load.reference_number)) }}<br />
                                <span>
                                    <strong>Rate:</strong> 
                                    <span v-if="load.rate">{{load.rate}}</span>
                                    <span v-else>{{notProvidedStr}}</span>
                                </span><br />
                            </div>
                            <div class='unset-case'>
                                <h1>OUTBOUND FREIGHT</h1>
                                <strong>Outbound:</strong> {{load.dest_city ? load.dest_city+', '+load.dest_short_name : anywhereStr}}:<strong> {{outboundFrieghts.destination_city_loads}} Load(s)</strong> <br/>
                                <strong>Outbound:</strong> {{load.dest_state ? load.dest_state : anywhereStr}}: <strong> {{outboundFrieghts.destination_state_loads}} Load(s)</strong>
                            </div>
                            <a class="v-btn--router orange white--text btnfull" @click="$router.go(-1)">
                                BACK
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div style="text-align: center;margin-top: 20px;color: #000;">{{noLoadExistMsg}}</div>
</div>
</template>
<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import utils from '../../util/';
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import config from "../../config";
import moment from "moment";
import { setTimeout } from 'timers';
import commonServices from "../../services/CommonService";
export default {
    components: {
        breadcrumbs,
        GoogleAds
    },
    created() {
        this.utils = utils;
        const self = this;
        services
            .get("aggregators/list", {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                if (res.status === 200) {
                    self.aggregators = res.data.data;
                    res.data.data.map(function(data){
                        self.aggregatorsKeyVal[data.name] = {};
                        data.AggregatorCode.map(function(data1){
                            self.aggregatorsKeyVal[data.name][data1.mapped_code] = data1.mapped_name;    
                        })
                    });
                }                    
            })
            .catch(err => {
                console.log(err.message)
            });
    },
    mounted() {
        const self = this,
            wApp = window.getApp,
            loadId = this.$route.params.id;
        self.clientUserAgent = utils.getUserAgent();    
        if (!loadId) {
            this.redirectAfterErr(config.invalidLoadIdMsg);
        } else {
            this.getLoadDetail(loadId);
        }
    },
    data() {
        return {
            aggregatorsKeyVal: {},
            noLoadExistMsg:'',
            clientUserAgent: config.clientUserAgent,
            notProvidedStr:config.notProvidedStr,
            anyStr:config.ANYStr,
            anyStrId:config.ANYStr,
            anywhereStr:config.anywhereStr,
            mcNumberLocation:config.mcNumberLocation,
            currDate: new Date(),
            permissionName: null,
            load: null,
            outboundFrieghts: null,
            equipment_types: [],
            equipment_type_codes:[],
            breadcrumbs: [{
                    name: 'Dashboard',
                    to: "/dashboard",
                    disabled: false
                },
                {
                    name: this.$route.meta.type=="loads" ? "My Loads" : "Load Search",
                    to: this.$route.meta.type=='loads' ? "/loads/list" : "/loads/search",
                    disabled: false
                },
                {
                    name: 'Load Details',
                    disabled: true
                }
            ]
        };
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        async getLoadDetail(loadId) {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            await commonServices.getEquipmentTypes(this.$store.state.user.token,"detail").then(res => {
                self.equipment_types = JSON.parse(JSON.stringify(res.equipment_types));
                self.equipment_type_codes = JSON.parse(JSON.stringify(res.equipment_type_codes));
                services.post("loads/loaddetailbyuuid", {"load_uuid": loadId, "is_view":true}, {"Authorization": "Bearer " + this.$store.state.user.token}).then(res => {
                    self.load = res.data.data.load_detail;
                    self.load.distance = utils.getDistanceDisplay(self.load.distance);
                    self.outboundFrieghts = res.data.data.outbound_frieghts;
                    utils.getEquipmentListDisplay(self.load.equipment_type_id,self.equipment_type_codes,self.equipment_types,config.longFormStr,function(result){
                        self.load["equipment_name_long_form"] = result;
                    });
                    utils.getEquipmentListDisplay(self.load.equipment_type_id,self.equipment_type_codes,self.equipment_types,config.shortFormStr,function(result){
                        self.load["equipment_name_short_form"] = result;
                    });
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    setTimeout(() => {
                        self.renderMap();
                    }, config.setTimeOutForLoadAndTruckDetailMap);
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if(typeof err.response.data.data.length === 'undefined'){
                        self.noLoadExistMsg = "This Load is no longer available.";
                    }
                    // self._showToast(err.message, config.errMsgColorStr);
                });
            })
            .catch(err =>{
                this._showToast(err.message, config.errMsgColorStr);
            });
        },
        renderMap() {
            if (this.load) {
                const load = this.load;
                let startAdd = new google.maps.LatLng(load.origin_lat, load.origin_lng);
                let endAdd = new google.maps.LatLng(load.dest_lat, load.dest_lng);
                const directionsDisplay = new google.maps.DirectionsRenderer,
                    directionsService = new google.maps.DirectionsService;
                const map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 7,
                    center: {
                        lat: 41.85,
                        lng: -87.65
                    }
                });
                directionsDisplay.setMap(map);
                directionsService.route({
                    origin: load.origin_lat + "," + load.origin_lng,
                    destination: load.dest_lat + "," + load.dest_lng,
                    travelMode: 'DRIVING'
                }, function (response, status) {
                    if (status === 'OK') {
                        let startContentString = '<div id="content" class="MarkerLabelFontCls">' + response.routes[0].legs[0].start_address + '</div>';
                        let startInfowindow = new google.maps.InfoWindow({
                            content: startContentString
                        });
                        // The marker, positioned at Uluru
                        let startMarker = new google.maps.Marker({
                            position: startAdd,
                            map: map,
                            icon: '/static/icon/map-marker-a.svg',
                            zIndex: 999
                        });
                        startMarker.addListener('click', function () {
                            startInfowindow.open(map, startMarker);
                        });


                        let endContentString = '<div id="content" class="MarkerLabelFontCls">' + response.routes[0].legs[0].end_address + '</div>';
                        let endInfowindow = new google.maps.InfoWindow({
                            content: endContentString
                        });
                        // The marker, positioned at Uluru
                        var endMarker = new google.maps.Marker({
                            position: endAdd,
                            map: map,
                            icon: '/static/icon/map-marker-b.svg',
                            zIndex: 999
                        });
                        endMarker.addListener('click', function () {
                            endInfowindow.open(map, endMarker);
                        });
                        directionsDisplay.setDirections(response);
                    } 
                });
            }
        },
        redirectAfterErr(msg) {
            this._showToast(msg, config.errMsgColorStr);
            this.$router.push("/roles/list");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/loads/Detail.vue